export const isName = (value) => {
    return value.match(/^[a-zа-я]+[a-zа-я- —]+?[a-zа-я]+$|^$/ig) !== null ||
           value.match(/^[a-zа-я]+$|^$/ig) !== null
}

export const isVin = (value) => {
    return value.match(/^[a-hj-npr-z0-9]+$|^$/ig) !== null
}

export const isPhone = (value) => {
    return value.indexOf('_') === -1
}

export const customPhoneMask = (value) => {
    const phoneMasks = {
        defaul: ['+', /\d/, '(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        7: ['+', /7/, '(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],

        373: ['+', /3/, /7/, /3/, '(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/],
        374: ['+', /3/, /7/, /4/, '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        375: ['+', /3/, /7/, /5/, '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        380: ['+', /3/, /8/, /0/, '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],

        992: ['+', /9/, /9/, /2/, '(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        994: ['+', /9/, /9/, /4/, '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
        996: ['+', /9/, /9/, /6/, '(', /\d/, /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
        998: ['+', /9/, /9/, /8/, '(', /\d/, /\d/, ')', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/],
    };

    let mask;
    let isInvalid = false;

    if(value.match(/^7/) || value.match(/^\+7/)) {
        mask = phoneMasks[7];
    }
    if(value.match('/^3/') || value.match(/^\+3/)) {
        mask = phoneMasks[373];
    }
    if(value.match('/^374/') || value.match(/^\+374/)) {
        mask = phoneMasks[374];
    }
    if(value.match('/^375/') || value.match(/^\+375/)) {
        mask = phoneMasks[375];
    }
    if(value.match('/^38/') || value.match(/^\+38/)) {
        mask = phoneMasks[380];
    }
    if(value.match('/^9/') || value.match(/^\+9/)) {
        mask = phoneMasks[992];
    }
    if(value.match('/^994/') || value.match(/^\+994/)) {
        mask = phoneMasks[994];
    }
    if(value.match('/^996/') || value.match(/^\+996/)) {
        mask = phoneMasks[996];
    }
    if(value.match('/^998/') || value.match(/^\+998/)) {
        mask = phoneMasks[998];
    }

    if(!mask && value) {
        mask = phoneMasks[7];
    }

    const validValues = [
        '_(___)', '+_', '+(',
        '7', '+7(', '+7', '+7_(', '+7___)',

        '3', '+3_(',
        '+38__(', '+38(',
        '+380',

        '+37__(', '+37(',
        '+373',
        '+374',
        '+375',

        '9', '+9_(',
        '+99__(', '+99(',
        '+992',
        '+994',
        '+996',
        '+998'
    ];

    let match = 0;

    validValues.forEach(validValue => {
        if (value.indexOf(validValue) === 0) {
            match++;
        }
    });

    if(value === '+') {
        match++;
    }

    if(value &&  !match) {
        isInvalid = true;
    }

    return {
        mask,
        isInvalid
    };
};



// WEBPACK FOOTER //
// ./src/validators/customValidators.js